<life-di-nav></life-di-nav>
<div class="container-fulid">
    <div class="picsum-img-wrapper">
        <img src="assets/learning-centerBanner.png" class="bannerWidth centerImg" alt="banner">
    </div>
    <!-- <ngb-carousel #carousel [interval]="5000">
        <ng-template ngbSlide *ngFor="let ban of banner; index as i">
        </ng-template>
    </ngb-carousel> -->
</div>

<div class="container py-5">
    <h1 class="text-center lifedi-color">ศูนย์เรียนรู้ย่อย</h1>
    <!-- <div class="content py-3 px-3">
        <p class="text-center text-content">
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur maNemo
            enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur ma
        </p>
    </div> -->
</div>

<div class="container">
    <div *ngIf="rows?.length > 0" class="row">
        <div *ngFor="let row of rows" class="col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
            <lifedi-learning-center-card [cardDetail]="row"
                (viewLearningCenter)="view(row.CENTER_ID)"></lifedi-learning-center-card>
        </div>
    </div>

    <div *ngIf="rows?.length === 0" class="my-3">
        <h2 class="text-center w-100">
            ยังไม่มีศูนย์เรียนรู้
        </h2>
    </div>

    <div class="d-flex justify-content-center p-2" *ngIf="rows">
        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
            (pageChange)="refresh()">
        </ngb-pagination>
    </div>
</div>

<lifedi-footer></lifedi-footer>